import { api } from './api';

export interface ExplainCellContext {
  accountCode: string;
  periodStart: string;
  periodEnd: string;
  scenarioA: string;
  scenarioB?: string;
  amountA: number;
  amountB?: number;
  delta?: number;
  factIds: string[];
}

export interface ExplainCellResult {
  narrative: string;
  citedFactIds: string[];
  costUsd: number;
}

export const explainCellApi = {
  explain: async (wsId: string, body: ExplainCellContext): Promise<ExplainCellResult> =>
    (await api.post(`/api/workspaces/${wsId}/explain-cell`, body)).data,
};
